import { CrossTemplate } from './CrossTemplate';

export type { TypeCrossTemplateProps } from './types';
export default CrossTemplate;
